/**
 * Route constants for the admin portal
 *
 * These constants define all application routes and should be used
 * throughout the application for navigation and route matching.
 */

export const ROUTES = {
  /** Dashboard landing page */
  DASHBOARD: '/',

  /** Tenant list page */
  TENANTS: '/tenants',

  /** Tenant detail page (requires tenantId parameter) */
  TENANT_DETAIL: '/tenants/:tenantId',

  /** User profile page */
  PROFILE: '/profile',

  /** Theme colors page */
  THEME: '/theme',
} as const

/**
 * Helper function to generate tenant detail route
 */
export const getTenantDetailRoute = (tenantId: string): string => {
  return `/tenants/${tenantId}`
}
